export class EmailContact {
    id: Number;
    email?: String;
    type?: {
        id?: number
    }
}